<template>
  <div id="release">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item>发布上线</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="title">发布上线</p>
    <div class="releaseContainer">
      <div class="headerInfo">
        <div class="img">
          <img :src="this.userInfo.skill_icon_url" class="img_url_box" alt="头像">
        </div>
        <div class="info">
          <div class="name">
            <span style="font-size: 20px;color: #505050;font-weight: 800;">{{userInfo.skill_name}}</span><span
            style="margin-left: 12px">{{userInfo.nlu_cate_name}}</span>
            <span class="ourStyle">{{userInfo.open_skill_type | openSkillType}}</span>
            <div style="margin-top: 4px;color: #989898;">{{userInfo.skill_intro}}</div>
          </div>
        </div>
      </div>

      <div style="width: 70%;border-bottom: 1px solid #eee;">
        <el-form ref="formReg" :rules="releaseCheck" :model="releaseInfo" label-width="200px">
          <el-form-item label="版本号：" prop="version_code">
            <el-col :span="20">
            <el-input :disabled="local" placeholder="请输入数值型版本号" v-model.trim="releaseInfo.version_code"
                      class="versionType" @input.native="changeRoute"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="表达示例：" required>
            <el-col :span="20">
              <el-form-item id="list0" prop="skill_order_word[0]" class="">
                <el-input :disabled="local" placeholder="请输入用户常用表达，支持50字符以内的中文、数字和英文"
                          v-model.trim="releaseInfo.skill_order_word[0]" @blur="exampleOne" @input.native="changeRoute"></el-input>
                <br/>
                <div class="el-form-item__error" id="errorOne">
                </div>
              </el-form-item>

            </el-col>
            <el-col :span="20">
              <el-form-item id="list1" prop="skill_order_word[1]">
                <el-input :disabled="local" placeholder="请输入用户常用表达，支持50字符以内的中文、数字和英文"
                          v-model.trim="releaseInfo.skill_order_word[1]" @blur="exampleTwo" @input.native="changeRoute"></el-input>
                <br/>
                <div class="el-form-item__error" id="errorTwo">
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="20" style="position: relative;">
               <el-form-item id="list2" prop="skill_order_word[2]">
                 <el-input :disabled="local" placeholder="请输入用户常用表达，支持50字符以内的中文、数字和英文"
                           v-model.trim="releaseInfo.skill_order_word[2]" @blur="exampleThree" @input.native="changeRoute"></el-input>
                 <br/>
                 <div :span="5" class="el-form-item__error" id="errorThree">
                 </div>
               </el-form-item>
              <el-button type="primary" icon="el-icon-plus" round size="mini" style="position: absolute;top:7px;right:-60px" @click="add_roder_word" v-if="!local" :disabled="!releaseInfo.skill_order_word[0] || !releaseInfo.skill_order_word[1] || !releaseInfo.skill_order_word[2] || releaseInfo.skill_order_word.length == 20"></el-button>
            </el-col>




            <el-col :span="20" v-for="(item, index) in releaseInfo.skill_order_word" style="position: relative;">
                <el-form-item :id="'list'+index" prop="skill_order_word[1]" v-if="index > 2" style="margin-bottom: 15px">
                  <el-input :disabled="local" placeholder="请输入用户常用表达，支持50字符以内的中文、数字和英文"
                            v-model.trim="releaseInfo.skill_order_word[index]" @blur="exampleIndex(index)" @input.native="changeRoute"></el-input>
                  <br/>
                  <div class="el-form-item__error" :id="'error'+index">
                  </div>
                </el-form-item>
                <i class="el-icon-circle-close deleteIcon pull-right"  v-if="index > 2 && !local" @click="remove_roder_word(index)" style="position: absolute;top:10px;right:-35px"></i>
            </el-col>




          </el-form-item>
          <el-form-item label="支持设备：" prop="smarthome_support_device" v-if="userInfo.open_skill_type == 2">
            <el-col :span="20">
            <el-input :disabled="local" type="textarea" v-model.trim="releaseInfo.smarthome_support_device"
                      placeholder="此处填写当前智能家居支持的设备" :autosize="{ minRows: 4, maxRows: 9}"
                      @input.native="changeRoute"
            ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="版本说明：" prop="version_explain">
            <el-col :span="20">
            <el-input :disabled="local" type="textarea" v-model.trim="releaseInfo.version_explain"
                      placeholder="请输入版本说明，长度在 50到 500 个字符" :autosize="{ minRows: 4, maxRows: 9}"
                      @input.native="changeRoute"
            ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="仅发布到指定设备：" prop="allow_client_id">
            <el-tooltip placement="top">
              <div slot="content">关闭开关，技能将发布到技能商店，所有搭载猎户语音OS的设备均可添加使用。<br/>打开开关，技能将发布到指定ClientID的设备，同时，仅指定ClientID的设备可以使用技能。</div>
              <i class="icon iconfont icon-wenhao blurIcon" name="tabs"></i>
            </el-tooltip>
            <el-col :span="20">
            <el-switch
                    :active-value="1"
                    :inactive-value="0"
                    v-model="releaseInfo.is_private"
                    :width="36"
                    active-color="#409EFF"
                    inactive-color="#dcdcdc">
            </el-switch>
            <el-input v-show="releaseInfo.is_private" spellcheck =“false” placeholder="请填写clientID,并用英文逗号隔开" @input.native="changeRoute" v-model.trim="releaseInfo.allow_client_id"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <p class="sub-btn-p" style="width: 90%; text-align: center;padding-bottom:20px;">
      <el-button type="primary" class="intentSavebtn" size="mini" round @click="saveMsg">保&nbsp;&nbsp;存</el-button>
      <!--<el-button type="primary" class="intentSavebtn intentSavebtn1" :disabled="local || (userInfo.open_skill_type == 2 && !releaseInfo.smarthome_support_device) || !releaseInfo.version_code || !releaseInfo.version_explain || !releaseInfo.skill_order_word[0] || !releaseInfo.skill_order_word[1] || !releaseInfo.skill_order_word[2]" size="mini" round @click="release(1)">发布到我的技能</el-button>-->
      <el-button type="primary" class="intentSavebtn intentSavebtn1" :disabled="local || (userInfo.open_skill_type == 2 && !releaseInfo.smarthome_support_device) || !releaseInfo.version_code || !releaseInfo.version_explain || skill_order_word_check" size="mini" round @click="release()">发布技能</el-button>
    </p>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>{{remindText}}</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="developer" style="margin-left:20px">{{confirmBtn}}</el-button>
  </span>
    </el-dialog>

  </div>
</template>
<script>
  import {releaseApi, saveReleaseApi, skillDetailApi, examineApi} from '@/api'
  import qs from 'qs'
  import commonMethods from '@/mixins/commonMethods'

  export default {
    mixins: [
      commonMethods
    ],
    data() {
      let checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入版本号'));
        }
        setTimeout(() => {
            let reg = /[^0-9\.]/g
            // /\D/g
          if (reg.test(value)) {
            callback(new Error('请输入数值型'));
          } else {
            if (value.length > 50 || value.length < 1) {
              callback(new Error('长度在 1到 50 个数字'));
            } else {
              callback();
            }
          }
        }, 200);
      };
        let check_allow_client_id = (rule, value, callback) => {
            setTimeout(() => {
                let reg = /^(orion\.ovs\.client\.\d{13},?)+$/
                if (!reg.test(value)) {
                    callback(new Error('请填写正确格式的clientID,例: orion.ovs.client.1234567890123,分隔用英文逗号'));
                } else {
                    callback();
                }
            }, 100);
        }
      return {
        imgUrl_bg: '',
        isPass: 0,
        remindText: '',
        confirmBtn: '',
        endpoint_uri_online: '',
        userInfo: {
          skill_id: '',
          skill_name: '',
          skill_domain: '',
          status: '',
          open_skill_type: '',
          nlu_cate_name: '',
          skill_icon_url: '',
          skill_intro: '',
          skill_version: "",//版本号
          skill_order_word: [],//表达用例
          skill_version_intro: "",//版本说明
        },
        releaseInfo: {
          skill_id: '',
          version_code: '',//版本号
          skill_order_word: [],//表达用例
          version_explain: '',//版本说明
          smarthome_support_device: '',//支持设备
          allow_client_id: ''
        },
        releaseCheck: {
          version_code: [
            {validator: checkAge, required: true, trigger: 'blur'}
          ],
          version_explain: [
                {required: true, message: '请输入版本说明', trigger: 'blur'},
                {min: 50, max: 500, message: '长度在 50到 500 个字符', trigger: 'blur'}
            ],
            allow_client_id: [
                {required: true, message: '请填写clientID,并用英文逗号隔开', trigger: 'blur'},
                {validator: check_allow_client_id, trigger: 'blur'}
            ],
            smarthome_support_device: [
                {required: true, message: '请输入支持的设备', trigger: 'blur'},
                {min: 2, max: 500, message: '长度在 2 到 500 个字符', trigger: 'blur'}
            ],
        },
        local: false,
        dialogVisible: false,
      }
    },
    created() {
      this.getSkillDetail()
      this.examine()
      this.isCanInput()
    },
    mounted() {

    },
    computed: {
        skill_order_word_check () {  // 动态判断表达示例 有没有空，有空不能发布技能
            for (let i = 0; i < this.releaseInfo.skill_order_word.length; i++) {
                const cur = this.releaseInfo.skill_order_word[i];
                if (!cur) {
                    return true
                }
            }
        }
     },
    methods: {
        // changeSwitch () {
        //   if (!this.releaseInfo.is_private) {
        //       // let allow_client_id = this.releaseInfo.allow_client_id
        //       // this.releaseInfo.allow_client_id = 'orion_ovs_client_1234567890987'
        //       // this.releaseInfo.allow_client_id = allow_client_id
        //   }
        // },
        add_roder_word () { // 新增表达示例
          this.releaseInfo.skill_order_word.push('')
        },
        remove_roder_word (index) { //删除表达示例
            this.releaseInfo.skill_order_word.splice(index, 1)
        },
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      async getSkillDetail() {//获取单个技能详情实现页面默认信息的相关填充
        let res = await skillDetailApi(qs.stringify({
          skill_id: this.$route.query.skillId,
          online: this.$route.query.online
        }))
        if (res.data.data.code == 200) {
            console.log(res.data.data.data)
            //console.log(res.data.data)
          if (res.data.data.data.skill_order_word.length == 0) {
            this.releaseInfo.skill_order_word == ["", "", ""];//表达用例

            this.endpoint_uri_online = res.data.data.data.endpoint_uri_online
            this.userInfo = res.data.data.data
            // this.releaseInfo = res.data.data.data
              for (var key in res.data.data.data) {
                  this.releaseInfo[key] = res.data.data.data[key]
              }
              this.releaseInfo.version_code = res.data.data.data.skill_version//版本号
            this.releaseInfo.version_explain = res.data.data.data.skill_version_intro//版本说明
          } else {
            this.endpoint_uri_online = res.data.data.data.endpoint_uri_online
            this.userInfo = res.data.data.data
            // this.releaseInfo = res.data.data.data
              for (var key in res.data.data.data) {
                this.releaseInfo[key] = res.data.data.data[key]
              }
            this.releaseInfo.version_code = res.data.data.data.skill_version//版本号
            this.releaseInfo.skill_order_word = JSON.parse(res.data.data.data.skill_order_word)//表达用例
            this.releaseInfo.version_explain = res.data.data.data.skill_version_intro//版本说明
            this.releaseInfo.smarthome_support_device = res.data.data.data.smarthome_support_device//支持设备

          }


//          this.userInfo.open_skill_type == 1 ? this.userInfo.open_skill_type = '自定义' : void(0)
        }
      },
      isCanInput() {
        if (localStorage.getItem('onlineFlag') == '1') {
          this.local = true;
        } else {
          this.local = false;
        }
      },
      async examine() {
        let res = await examineApi()
        if (res.data.code == 200) {
          if (res.data.data.user_type) {
            this.isPass = res.data.data.status;
            //console.log(res.data);
          }
        }
      },
      developer() {
        this.$router.push('/developer')
        this.dialogVisible = false
      },

      //验证表达用例1
      exampleOne() {
        let regOne = /^[A-Za-z0-9\u4e00-\u9fa5]*$/;//中文、数字和英文
        //console.log(this.releaseInfo.skill_order_word[0])
        if (this.releaseInfo.skill_order_word[0] == undefined) {
          document.getElementById("list0").className = "el-form-item is-error";
          document.getElementById("errorOne").innerHTML = "输入不能为空";

        } else if (!regOne.test(this.releaseInfo.skill_order_word[0]) || this.releaseInfo.skill_order_word[0].length < 0 || this.releaseInfo.skill_order_word[0].length > 50) {
          document.getElementById("list0").className = "el-form-item is-error";
          document.getElementById("errorOne").innerHTML = "请输入正确格式的表达用例，50个字符以内";
        } else if (this.releaseInfo.skill_order_word[0].length == 0) {
          document.getElementById("list0").className = "el-form-item is-error";
          document.getElementById("errorOne").innerHTML = "输入不能为空";
        } else {
          document.getElementById("list0").className = "el-form-item";
          document.getElementById("errorOne").innerHTML = "";
        }
      },

      //验证表达用例2
      exampleTwo() {
        let regOne = /^[A-Za-z0-9\u4e00-\u9fa5]*$/;//中文、数字和英文
        // console.log(this.releaseInfo.skill_order_word[1])
        if (this.releaseInfo.skill_order_word[1] == undefined) {
          document.getElementById("list1").className = "el-form-item is-error";
          document.getElementById("errorTwo").innerHTML = "输入不能为空";
        } else if (!regOne.test(this.releaseInfo.skill_order_word[1]) || this.releaseInfo.skill_order_word[1].length < 0 || this.releaseInfo.skill_order_word[1].length > 50) {
          document.getElementById("list1").className = "el-form-item is-error";
          document.getElementById("errorTwo").innerHTML = "请输入正确格式的表达用例，50个字符以内";
        } else if (this.releaseInfo.skill_order_word[1].length == 0) {
          document.getElementById("list1").className = "el-form-item is-error";
          document.getElementById("errorTwo").innerHTML = "输入不能为空";
        } else {
          document.getElementById("list1").className = "el-form-item";
          document.getElementById("errorTwo").innerHTML = "";
        }
      },

      //验证表达用例3
      exampleThree() {
        let regOne = /^[A-Za-z0-9\u4e00-\u9fa5]*$/;//中文、数字和英文
        //console.log(this.releaseInfo.skill_order_word[2])
        if (this.releaseInfo.skill_order_word[2] == undefined) {
          document.getElementById("list2").className = "el-form-item is-error";
          document.getElementById("errorThree").innerHTML = "输入不能为空";
        } else if (!regOne.test(this.releaseInfo.skill_order_word[2]) || this.releaseInfo.skill_order_word[2].length < 0 || this.releaseInfo.skill_order_word[2].length > 50) {
          document.getElementById("list2").className = "el-form-item is-error";
          document.getElementById("errorThree").innerHTML = "请输入正确格式的表达用例，50个字符以内";

        } else if (this.releaseInfo.skill_order_word[2].length == 0) {
          document.getElementById("list2").className = "el-form-item is-error";
          document.getElementById("errorThree").innerHTML = "输入不能为空";
        } else {
          document.getElementById("list2").className = "el-form-item";
          document.getElementById("errorThree").innerHTML = "";
        }
      },

        //验证表达用例,新增
        exampleIndex(index) {
            let regOne = /^[A-Za-z0-9\u4e00-\u9fa5]*$/;//中文、数字和英文
            //console.log(this.releaseInfo.skill_order_word[2])
            if (this.releaseInfo.skill_order_word[index] == undefined) {
                document.getElementById("list"+index).className = "el-form-item is-error";
                document.getElementById("error"+index).innerHTML = "输入不能为空";
            } else if (!regOne.test(this.releaseInfo.skill_order_word[index]) || this.releaseInfo.skill_order_word[index].length < 0 || this.releaseInfo.skill_order_word[index].length > 50) {
                document.getElementById("list"+index).className = "el-form-item is-error";
                document.getElementById("error"+index).innerHTML = "请输入正确格式的表达用例，50个字符以内";

            } else if (this.releaseInfo.skill_order_word[index].length == 0) {
                document.getElementById("list"+index).className = "el-form-item is-error";
                document.getElementById("error"+index).innerHTML = "输入不能为空";
            } else {
                document.getElementById("list"+index).className = "el-form-item";
                document.getElementById("error"+index).innerHTML = "";
            }
        },

      async saveMsg() {
          this.$store.dispatch('changeR',true);//保存后 跳转页面不提示
        this.releaseInfo.skill_id = this.$route.query.skillId
        let saveData = {
          skill_id: this.releaseInfo.skill_id,
          audit_status: this.releaseInfo.audit_status,
          version_code: this.releaseInfo.version_code,
          skill_order_word: JSON.stringify(this.releaseInfo.skill_order_word) ,
          version_explain: this.releaseInfo.version_explain,
          smarthome_support_device: this.releaseInfo.smarthome_support_device,
            is_private: this.releaseInfo.is_private,
            allow_client_id:  this.releaseInfo.allow_client_id
        };
          if (this.releaseInfo.is_private) {
              let reg = /^(orion\.ovs\.client\.\d{13},?)+$/
              if (!this.releaseInfo.allow_client_id) {
                  this.$message({message: '请填写clientID,并用英文逗号隔开', type: 'error'})
                  return
              }
              if (!reg.test(this.releaseInfo.allow_client_id)) {
                  this.$message({message: '请填写正确格式的clientID', type: 'error'})
                  return
              }
          }
        let res = await saveReleaseApi(qs.stringify(saveData));
        if (res.data.code == 200) {
          this.$message({message: '内容保存成功', type: 'success'});
        }  else {
            if (res.data.errors.data) {
                this.$message({message: res.data.errors.data, type: 'error'});
            } else {
                this.$message({message: '当前网络异常，请稍后测试', type: 'error'});
            }
        }
      },

      async release(isPrivate) {
        if (this.isPass != 2) {
//          this.$message({message: '请先认证开发者信息', type: 'error'})
          if (this.isPass == 1) {
            this.dialogVisible = true
            this.remindText = "您的开发者审核未通过，请立即认证"
            this.confirmBtn = "重新认证"
            return
          } else if (this.isPass == 3) {
            this.dialogVisible = true
            this.remindText = "您的开发者认证审核中，请前往查看认证进度"
            this.confirmBtn = "查看认证"
            return

          } else if (this.isPass == 0) {
            this.dialogVisible = true
            this.remindText = "您还未进行开发者认证，请立即进行认证"
            this.confirmBtn = "立即认证"
            return
          }

        }
        if (this.endpoint_uri_online == '') {
          this.$message({message: '该技能未配置服务，请先配置服务后上线', type: 'error'})
          return
        }
        if (/[^0-9\.]/g.test(this.releaseInfo.version_code)) {
//          this.$message({message: '请填写版本号,1~50个数字', type: 'error'})
          this.$root.scroll_top()
          return
        }
        if (this.releaseInfo.version_code == '' || this.releaseInfo.version_code.length < 1 || this.releaseInfo.version_code.length > 50) {
          this.$root.scroll_top()
          return
        }
        let regOne = /^[A-Za-z0-9\u4e00-\u9fa5]*$/;//中文、数字和英文
        //console.log(this.releaseInfo.skill_order_word[0])
          for (let i = 0; i < this.releaseInfo.skill_order_word.length; i++) {
              const cur = this.releaseInfo.skill_order_word[i]

              if (cur == undefined) {
                  this.$message({message: '请输入正确格式的表达用例，1~50个字符', type: 'error'})
                  return

              } else if (!regOne.test(cur) || cur.length < 0 || cur.length > 50) {
                  this.$message({message: '请输入正确格式的表达用例，1~50个字符', type: 'error'})
                  return
              } else if (cur.length == 0) {
                  this.$message({message: '请输入正确格式的表达用例，1~50个字符', type: 'error'})
                  return
              }
          }

        if (this.userInfo.open_skill_type == 2) { //智能家居类型
            if (this.releaseInfo.smarthome_support_device == '' || this.releaseInfo.smarthome_support_device.length < 2 || this.releaseInfo.smarthome_support_device.length > 500) {
                this.$message({message: '请填写支持设备信息,50~500个字符', type: 'error'})
                return
            }
        }

        if (this.releaseInfo.version_explain == '' || this.releaseInfo.version_explain.length < 50 || this.releaseInfo.version_explain.length > 500) {
          this.$message({message: '请填写版本说明,50~500个字符', type: 'error'})
          return
        }
        if (this.releaseInfo.is_private) {
            let reg = /^(orion\.ovs\.client\.\d{13},?)+$/
            if (!this.releaseInfo.allow_client_id) {
                this.$message({message: '请填写clientID,并用英文逗号隔开', type: 'error'})
                return
            }
            if (!reg.test(this.releaseInfo.allow_client_id)) {
                this.$message({message: '请填写正确格式的clientID', type: 'error'})
                return
            }
        }
        this.releaseInfo.skill_id = this.$route.query.skillId
            let res = await releaseApi(qs.stringify(this.releaseInfo));
        if (res.data.code == 200) {
          this.$message({message: '申请上线成功', type: 'success'});
          localStorage.setItem('onlineFlag', '1');
          this.$router.push(`/edition?skillId=${this.$route.query.skillId}&online=${this.$route.query.online}`)
        } else if (res.data.code == 401) {
          window.location.href = '/login'
        } else {
          this.$message({message: res.data.errors.data, type: 'error'})
        }
      }

    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #release {
    background: #fff;
    padding-top: 0;
    #errorOne,#errorTwo,#errorThree{
      top:90%;
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .releaseContainer {
      padding: 20px 30px 30px;
    }
    .deleteIcon {
      font-size: 20px;
      color: #ccc;
    }
    .blurIcon {
      color: #7abaf1;
    }
    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -18px;
      }
    }
    .deleteIcon:hover {
      color: #f56c6c;
    }
    .el-form {
      padding: 20px 0px;
      .el-input {
        height: 28px !important;
        line-height:  28px;
        border-radius: 14px !important;
      }
      /*.versionType {*/
        /*width: 240px;*/
      /*}*/
      .el-input__inner {
        height: 28px !important;
        line-height:  28px;
        border-radius: 14px !important;
      }

    }

    #list0 {
      margin-bottom: 10px;
    }
    #list1 {
      margin-bottom: 10px;
    }
    #list2 {
      margin-bottom: 10px;
    }
    .el-textarea {
      width: 100%;
      border-radius: 14px;
    }
    .headerInfo {
      width: 70%;
      padding: 20px 30px;
      background: #fbfbfb;
      overflow: hidden;
      .img {
        width: 71px;
        height: 71px;
        float: left;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
      }
      .info {
        float: left;
        font-size: 12px;
        color: #6c6c6c;
        width: calc(100% - 91px);
        .name {

          span {

          }
        }
        .info_main {
          span {
            display: inline-block;
            margin: 5px 38px 5px 0;
          }
        }
      }

      .info .name .ourStyle {
        background: #7d7d7d;
        height: 18px;
        line-height: 18px;
        border-radius: 1px;
        color: #fff;
        width: 62px;
        text-align: center;
        position: absolute;
        right: 30px;
        top: 27px;
      }
      position: relative;
    }
    .main-info {
      padding: 20px 0;
      input {
        width: 240px;
        height: 28px;
        border-radius: 14px;
      }
    }
    .sub-btn-p {
      text-align: center;
      margin-bottom: 30px;
    }
    textarea {
      border-radius: 14px;
    }
  }

  //by zhaoyuqing
  /*#release {
    background: #fff;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }

    button {
      margin-left: 45%;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-textarea__inner {
      width: 80%;
      border-radius: 14px;
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/setting/Release.vue